// エンコーディング処理ユーティリティ
// encoding-japaneseはindex.htmlでCDNから読み込まれるため、window.Encodingを使用

declare global {
  interface Window {
    Encoding?: {
      stringToCode: (str: string) => number[];
      convert: (array: number[], options: { to: string; from: string }) => number[];
    };
  }
}

/**
 * 2バイト文字が含まれているかチェック
 * @param str - チェックする文字列
 * @returns 2バイト文字が含まれている場合true
 */
export function containsMultiByteChars(str: string): boolean {
    // 2バイト文字（日本語、中国語、韓国語など）が含まれているかチェック
    return /[^\x00-\x7F]/.test(str);
}

/**
 * バッチファイルをShift-JISエンコードしてBlobを作成
 * @param code - バッチファイルのコード
 * @returns エンコードされたBlob
 */
export function createBatchFileBlob(code: string): Blob {
    // 改行コードをWindows標準のCRLFに正規化
    // 1. 既存のCRLFをLFに揃える
    // 2. LFをCRLFに変換することで、混在している場合も含めて必ずCRLFにする
    const normalizedCode = code
        .replace(/\r\n/g, '\n')
        .replace(/\n/g, '\r\n');

    let blob: Blob;
    
    // 2バイト文字が含まれている場合はShift-JISでエンコード
    if (containsMultiByteChars(normalizedCode)) {
        try {
            // UTF-8からShift-JISに変換
            if (typeof window === 'undefined' || !window.Encoding) {
                throw new Error('Encoding library not available');
            }
            const Encoding = window.Encoding;
            const utf8Array = Encoding.stringToCode(normalizedCode);
            const sjisArray = Encoding.convert(utf8Array, {
                to: 'SJIS',
                from: 'UNICODE'
            });
            blob = new Blob([new Uint8Array(sjisArray)], { type: 'text/plain;charset=shift_jis' });
        } catch (e) {
            console.warn('Shift-JIS変換に失敗しました。UTF-8で保存します:', e);
            // 変換に失敗した場合はUTF-8で保存（BOM付き）
            const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
            const utf8Array = new TextEncoder().encode(normalizedCode);
            blob = new Blob([bom, utf8Array], { type: 'text/plain;charset=utf-8' });
        }
    } else {
        // 2バイト文字が含まれていない場合はUTF-8で保存
        blob = new Blob([normalizedCode], { type: 'text/plain;charset=utf-8' });
    }
    
    return blob;
}

